/* eslint-disable linebreak-style */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/display-name */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useAmp } from 'next/amp';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import Col from 'base-ui/dist/Col';
import Container from 'base-ui/dist/Container';
import PageWrapper from 'base-ui/dist/PageWrapper';
import Row from 'base-ui/dist/Row';
import Box from 'base-ui/dist/Box';
import Heading from 'base-ui/dist/Heading';
import NavLink from 'components/NavLink';
import isBrowser from 'utils/isBrowser';
import { Sentry } from 'root/utils/raven';
import { useAuth } from 'root/hooks/useAuth';
import apiClient from '../../lib/apiClient';

const getConfig = require('next/config').default;

const RenderHtmlReactLoading = dynamic(
  () => import('utils/RenderHtmlReact/Loading'));
const BreadcrumbsLoading = dynamic(
  () => import('components/Breadcrumbs/Loading'));
const PostMetasLoading = dynamic(() => import('components/PostMetas/Loading'));
const AuthorSignedCardLoading = dynamic(
  () => import('components/AuthorSignedCard/Loading'));
const PostBibliographyLoading = dynamic(
  () => import('components/PostBibliography/Loading'));
const SponsorBoxLoading = dynamic(
  () => import('components/SponsorBox/Loading'));
const ShareButtonsLoading = dynamic(
  () => import('components/ShareButtons/Loading'));

const RenderHtmlReact = dynamic(
  () => import('utils/RenderHtmlReact'),
  {
    loading: () => (
      <RenderHtmlReactLoading
        mobile={{
          width: '480',
          height: '300',
        }}
        desktop={{
          width: '618',
          height: '500',
        }}
      />
    ),
  });
const Breadcrumbs = dynamic(
  () => import('components/Breadcrumbs'),
  {
    loading: () => (
      <BreadcrumbsLoading
        mobile={{
          width: '480',
          height: '20',
        }}
        desktop={{
          width: '618',
          height: '20',
        }}
      />
    ),
  });
const PostMetas = dynamic(
  () => import('components/PostMetas'),
  {
    loading: () => (
      <PostMetasLoading
        mobile={{
          width: '480',
          height: '20',
        }}
        desktop={{
          width: '618',
          height: '20',
        }}
      />
    ),
  });
const AuthorSignedCard = dynamic(
  () => import('components/AuthorSignedCard'),
  {
    loading: () => (
      <AuthorSignedCardLoading
        mobile={{
          width: '480',
          height: '84',
        }}
        desktop={{
          width: '618',
          height: '84',
        }}
      />
    ),
  });
const PostBibliography = dynamic(
  () => import('components/PostBibliography'),
  {
    loading: () => (
      <PostBibliographyLoading
        mobile={{
          width: '480',
          height: '64',
        }}
        desktop={{
          width: '618',
          height: '64',
        }}
      />
    ),
  });
const SponsorBox = dynamic(
  () => import('components/SponsorBox'),
  {
    loading: () => (
      <SponsorBoxLoading
        mobile={{
          width: '480',
          height: '84',
        }}
        desktop={{
          width: '618',
          height: '84',
        }}
      />
    ),
  });

const ShareButtons = dynamic(
  () => import('components/ShareButtons'),
  {
    loading: () => (
      <ShareButtonsLoading
        mobile={{
          width: '480',
          height: '40',
        }}
        desktop={{
          width: '110',
          height: '212',
        }}
      />
    ),
  });

const SymptomsBox = dynamic(() => import('components/SymptomsBox'));
const RelatedDiseasesBox = dynamic(() => import('components/RelatedDiseasesBox'));
const SummaryBox = dynamic(() => import('components/SummaryBox'));
const Image = dynamic(() => import('components/Image'));
const SEO = dynamic(() => import('components/SEO'));
const AdManager = dynamic(() => import('components/AdManager'));
const Sidebar = dynamic(() => import('components/Sidebar'));

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const getTargets = (post) => ({
  tags: post?.tags?.map((i) => i.name),
  postId: post.id,
  author: post?.author?.slug,
  authorId: post?.author?.id,
  section: 'single',
});

const Disease = ({ post, preview, fbp }) => {
  const { isPhone } = useDeviceScreen();
  const isAmp = useAmp();

  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  Sentry.addBreadcrumb({
    category: 'screens/Disease',
    message: `Render disease ${post?.link}`,
    level: Sentry.Severity.Debug,
  });

  useEffect(() => {
    if (fbp && isBrowser() && publicRuntimeConfig.dmp) {
      const tags = post?.tags?.map((v) => v.name);

      fbp.trackSingleCustom(publicRuntimeConfig.FACEBOOK_PIXEL_DMP,
        'ViewMSContent', {
          content_cat7: post.categories && post.categories.length
            ? post.categories[0].name
            : '',
          content_tags: tags && tags.length ? tags : [],
        });
    }
  }, [post, fbp]);

  return (
    <React.Fragment>
      <SEO resource={post} />
      <Container fluid wrap>
        <Row>
          <Col xs="12">
            <Breadcrumbs breadcrumbs={post.breadcrumbs || []} className={'margin-top-medium'} />
          </Col>
        </Row>
      </Container>
      <PageWrapper config={{ title: post.metas?.title, bodyClasses: 'single-landing' }}>
        <Box tag="main" id="site-main">
          <Container fluid wrap>
            <Row>
              <Col xs="12" md={isPhone || isAmp ? 12 : 8} sm="12">
                <Box tag="section" className={'section-text section-intro margin-bottom-big'}>
                  <Heading type={'h1'}>
                    <NavLink>
                      {post?.title}
                    </NavLink>
                  </Heading>

                  <PostMetas post={{ ...post, options: { ...post.options, author: 'off' } }} dateIcon="calendar" />

                  {isPhone && (
                    <>
                      <figure>
                        <Image src={post?.featured_media} alt={post.title} />
                      </figure>
                      <hr />
                    </>
                  )}

                  {post?.author && (
                    <AuthorSignedCard
                      author={post.author}
                      reviewed_by={post.reviewed_by}
                    />
                  )}

                  {post?.headline && (
                    <blockquote
                      dangerouslySetInnerHTML={{
                        __html: post.headline,
                      }}
                    />
                  )}

                  {!preview && (
                    <AdManager
                      type="box"
                      display={{
                        desktop: false,
                        tablet: false,
                        mobile: post?.options?.ads === 'on',
                      }}
                      targets={getTargets(post)}
                    />
                  )}

                  {!isPhone && (
                    <>
                      <figure>
                        <Image src={post?.featured_media} alt={post.title} />
                      </figure>
                      <hr />
                    </>
                  )}

                  {!preview && (
                    <AdManager
                      type="box"
                      display={{
                        desktop: post?.options?.ads === 'on',
                        tablet: post?.options?.ads === 'on',
                        mobile: false,
                      }}
                      targets={getTargets(post)}
                    />
                  )}

                  <div className="the-content">
                    <RenderHtmlReact
                      text={post.content}
                      post={post}
                      preview={preview}
                    />
                  </div>

                  <div id="single">
                    {post?.bibliography && <PostBibliography bibliography={post?.bibliography} />}
                  </div>
                  {(post?.options?.is_sponsored && post?.options?.sponsor)
                  && <SponsorBox sponsor={post?.options?.sponsor} />}

                  { (isPhone || isAmp) && post?.summary ? (
                    <SymptomsBox symptoms={post?.symptoms} />
                  ) : null }

                  { post?.disease_type[0] && <RelatedDiseasesBox posts={post?.related_diseases} disease={post?.disease_type[0]} /> }

                  <ShareButtons
                    post={post}
                    isAuthenticated={isAuthenticated}
                    bookmarks={bookmarks}
                    handleBookmarks={setBookmarks}
                  />

                  <Sidebar
                    sidebarSlug="single-lower-sidebar"
                    preview={preview}
                    ads={{
                      enabled: post?.options?.ads === 'on',
                      targets: getTargets(post),
                    }}
                  />
                </Box>
              </Col>
              {!isPhone && !isAmp && (
                <aside id="sidebar" className="col-xs-12 col-md-4 hidden-md">
                  {(post?.summary && Array.isArray(post?.summary)) && (
                    <SummaryBox summary={post?.summary} permalink={post?.permalink} />
                  )}
                  <Box className="box-publicity align-center margin-top-medium margin-bottom-medium">
                    <AdManager
                      type="box"
                      display={{
                        desktop: post?.options?.ads === 'on',
                        tablet: post?.options?.ads === 'on',
                        mobile: false,
                      }}
                      targets={getTargets(post)}
                    />
                  </Box>

                  {post?.symptoms && <SymptomsBox symptoms={post?.symptoms} />}

                  <Sidebar
                    sidebarSlug="single-sidebar"
                    preview={preview}
                    ads={{
                      enabled: post?.options?.ads === 'on',
                      targets: getTargets(post),
                    }}
                  />
                </aside>
              )}
            </Row>
          </Container>
        </Box>
      </PageWrapper>
    </React.Fragment>
  );
};

Disease.propTypes = {
  post: PropTypes.object,
  preview: PropTypes.bool,
  fbp: PropTypes.object,
};

export default Disease;
